import dayjs from 'dayjs'

import translationKeys from '@translationKeys'

import { User } from '@modules/auth/hooks/types'
import { ProfileType } from '@modules/search/types'

import { PendoCorporateHistoryEventType, PendoImportProspectsEventType } from '../types'
import { getEventDefaultInfo } from '../utils'

export * from './markAsViewedEventData'
export * from './savedSearchEventData'
export * from './searchEventData'
export * from './sortEventData'
export * from './customListEventData'

export const preparePendoImportProspectsEvent = ({
  eventType,
  location,
  user,
  eventName,
  profileId,
  participantId,
  filterNames,
}: {
  eventType: PendoImportProspectsEventType
  location?: string
  user?: User | null
  eventName?: string
  profileId?: number
  participantId?: number
  filterNames?: string[]
}) => ({
  ...getEventDefaultInfo(user, location),
  eventType,
  eventName,
  profileId,
  profileType: ProfileType.company,
  participantId,
  filterNames,
})

export const preparePendoCorporateHistoryEvent = (data: {
  meetingStatus?: string
  eventName?: string
  date: string
  user?: User | null
  location: string
  eventType: PendoCorporateHistoryEventType
}) => {
  const { user, meetingStatus, date, eventName, location, eventType } = data
  return {
    ...getEventDefaultInfo(user),
    location,
    eventType,
    date_selected: dayjs(date).format('DD/MM/YYYY'),
    event_name: eventName,
    meeting_status: meetingStatus ?? 'Multiple Statuses',
  }
}

export const preparePendoContactMessageEvent = (data: {
  user?: User | null
  location: string
  event: string
  sortType?: string
  menuClickType?: string
  chatInfo?: { type: string; id: number | string }
}) => {
  const { user, event, sortType, menuClickType, location, chatInfo } = data
  return {
    ...getEventDefaultInfo(user),
    location,
    eventType: event,
    sort: sortType,
    menu_option: menuClickType,
    chat_opened: chatInfo,
  }
}

export const preparePendoSearchGroupingEvent = ({
  groupingOptionId,
  user,
  eventType,
}: {
  groupingOptionId: number | null
  user?: User | null
  eventType: string
}) => {
  return {
    ...getEventDefaultInfo(user),
    location: 'search_page',
    eventType,
    option: groupingOptionId ? translationKeys.GROUP_BY_COMPANY : translationKeys.NO_GROUPING,
  }
}

export const preparePendoCustomListEvent = ({
  eventType,
  customListId,
  user,
}: {
  eventType: string
  customListId?: number | null
  user?: User | null
}) => {
  return {
    ...getEventDefaultInfo(user),
    location: 'custom-lists-page',
    eventType,
    customListId,
  }
}
